"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = exports.addDistributionList = exports.addRecipient = exports.listView = exports.mapStateToProps = void 0;
exports.isFetching = isFetching;
exports.hasError = hasError;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var uuid_1 = require("uuid");
var fp = require("fp-ts");
var sok_ui_1 = require("@caddigital/sok-ui");
var AddRecipients_1 = require("components/OrderAndDistributionComponents/AddRecipients");
var AddressBook_1 = require("components/OrderAndDistributionComponents/AddressBook");
var DistributionRecipients_1 = require("components/OrderAndDistributionComponents/DistributionRecipients");
var AddDistributionLists_1 = require("components/OrderAndDistributionComponents/AddDistributionLists");
var DistributionLists_1 = require("components/OrderAndDistributionComponents/DistributionLists");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var distributionListsActions = require("@caddigital/sok-reducers/lib/actions/order/distributionLists");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/order/wizard");
var deliveryMethodsActions = require("@caddigital/sok-reducers/lib/actions/order/deliveryMethods");
var finishingsActions = require("@caddigital/sok-reducers/lib/actions/order/finishings");
var printProvidersActions = require("@caddigital/sok-reducers/lib/actions/order/printProviders");
var BillingInformationsActions = require("@caddigital/sok-reducers/lib/actions/order/billingInformations");
var AddressBookActions = require("@caddigital/sok-reducers/lib/actions/order/addressBook");
var RecipientsActions = require("@caddigital/sok-reducers/lib/actions/order/recipients");
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var Types = require("types");
var addNewRecipient_1 = require("../../modals/addNewRecipient");
var functions_1 = require("components/OrderAndDistributionComponents/helpers/functions");
var quantities = (0, functions_1.getQuantitiesList)();
var noRecipientIcon = '/assets/sokopro_mario_icon.svg';
var mapStateToProps = function (state) { return ({
    addressBook: state.order.addressBook,
    recipients: state.order.recipients,
    distributionLists: state.order.distributionLists,
    values: state.order.wizard.values,
    deliveryMethods: state.order.deliveryMethods,
    finishings: state.order.finishings,
    printProviders: state.order.printProviders,
    step2: state.order.wizard.step2,
    wizard: state.order.wizard
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    changeStep2View: function (view) { return function () {
        return dispatch(WizardActions.step2ChangeDisplay(view));
    }; },
    setDesiredDeliveryTime: function (date) {
        return dispatch(WizardActions.valuesSetRequestTimeOfDelivery(date.format()));
    },
    fetchBillingInformations: function (project) { return function () {
        return dispatch(BillingInformationsActions.fetchBillingInformationsRequest(project));
    }; },
    fetchOrderInformations: function () { return (dispatch(deliveryMethodsActions.Actions.fetchRequest()),
        dispatch(finishingsActions.Actions.fetchRequest()),
        dispatch(printProvidersActions.Actions.fetchRequest())); },
    selectRecipientsList: function (ids) { return function () {
        return dispatch(RecipientsActions.select(ids));
    }; },
    unselectRecipientsList: function (ids) { return function () {
        return dispatch(RecipientsActions.unselect(ids));
    }; },
    removeDistributionRecipient: function (uuid) { return function () {
        return dispatch(WizardActions.valuesRemoveDistributionRecipient(uuid));
    }; },
    changeDistributionRecipientQuantity: function (uuid) {
        return function (_a) {
            var value = _a.value;
            return dispatch(WizardActions.valuesChangeDistributionRecipientQuantity(uuid, value));
        };
    },
    changeDistributionRecipientFinishing: function (uuid) {
        return function (_a) {
            var id = _a.id;
            return dispatch(WizardActions.valuesChangeDistributionRecipientFinishing(uuid, id));
        };
    },
    changeDistributionRecipientDeliveryMethod: function (uuid) {
        return function (_a) {
            var id = _a.id;
            return dispatch(WizardActions.valuesChangeDistributionRecipientDeliveryMethod(uuid, id));
        };
    },
    changeDistributionRecipientPrintProvider: function (uuid) {
        return function (_a) {
            var id = _a.id;
            return dispatch(WizardActions.valuesChangeDistributionRecipientPrintProvider(uuid, id));
        };
    },
    fetchRecipients: function (project) { return function () {
        return dispatch(RecipientsActions.fetchRequest(project));
    }; },
    addDistributionRecipient: function (data, selected) {
        return function () { return (dispatch(WizardActions.valuesAddOrderRecipients(data.map(function (d) { return (__assign(__assign({}, d), { excluded: false, uuid: (0, uuid_1.v4)() })); }))),
            dispatch(WizardActions.step2ChangeDisplay('LIST')),
            dispatch(RecipientsActions.unselect(selected)),
            dispatch(AddressBookActions.unselect(selected))); };
    },
    removeDistributionList: function (list) { return function () {
        return dispatch(WizardActions.valuesRemoveDistributionLists([list]));
    }; },
    changeStep2AddNewDeliveryAddress: function (status) { return function () {
        return dispatch(WizardActions.step2AddRecipientAddNewDeliveryAddress(status));
    }; },
    changeStep2Tab: function (tab) {
        return dispatch(WizardActions.step2AddRecipientTab(tab));
    },
    addDistributionList: function (props, lists) {
        return function () {
            var x = lists.reduce(function (arr, x) {
                var recipients = x.recipients.map(function (r) {
                    return __assign(__assign({}, r), { printProvider: props.currentProject
                            ? props.currentProject.printProvider || -1
                            : -1 });
                });
                arr.push(__assign(__assign({}, x), { recipients: recipients }));
                return arr;
            }, []);
            dispatch(WizardActions.valuesAddDistributionLists(x)),
                dispatch(WizardActions.step2ChangeDisplay('LIST')),
                dispatch(distributionListsActions.unselect(props.distributionLists.selected));
        };
    },
    selectAddressBookList: function (ids) { return function () {
        return dispatch(AddressBookActions.select(ids));
    }; },
    unselectAddressBookList: function (ids) { return function () {
        return dispatch(AddressBookActions.unselect(ids));
    }; },
    fetchExternalUsers: function (folder) { return function () {
        return dispatch(AddressBookActions.fetchRequest(folder));
    }; },
    changeStep2DistributionListsSearch: function (project) { return function () {
        dispatch(distributionListsActions.fetchRequest(project));
    }; },
    selectDistributionList: function (ids) { return function () {
        return dispatch(distributionListsActions.select(ids));
    }; },
    unselectDistributionList: function (ids) { return function () {
        return dispatch(distributionListsActions.unselect(ids));
    }; },
    fetchDistributionLists: function (project) { return function () {
        return dispatch(distributionListsActions.fetchRequest(project));
    }; },
    closeDistributionListView: function (props) { return function () { return (dispatch(WizardActions.step2ChangeDisplay('LIST')),
        dispatch(distributionListsActions.unselect(props.distributionLists.selected))); }; },
    excludeRecipient: function (id) { return function () {
        if (id !== undefined) {
            dispatch(WizardActions.excludeRecipient(id));
        }
    }; },
    backToList: function (props) {
        return function () { return (dispatch(WizardActions.step2ChangeDisplay('LIST')),
            dispatch(RecipientsActions.unselect(props.recipients.selected)),
            dispatch(AddressBookActions.unselect(props.addressBook.selected))); };
    }
}); };
//#region Types
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToPropsExtractable = Types.extractReturnType(mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, mapDispatchToProps), recompose_1.pure);
function isFetching(props) {
    return (props.deliveryMethods.status === 'FETCHING' ||
        props.finishings.status === 'FETCHING' ||
        props.printProviders.status === 'FETCHING');
}
function hasError(props) {
    return (props.deliveryMethods.status === 'FAILED' ||
        props.finishings.status === 'FAILED' ||
        props.printProviders.status === 'FAILED');
}
var distributionListRecipients = function (props) {
    return props.values.distributionLists
        .sort(function (a, b) { return a.name.localeCompare(b.name); })
        .map(function (l) {
        return l.recipients
            .filter(function (r) { return (props.mode === 'VIEW' && props.type === 'SINGLE') || r.user; })
            .sort(function (a, b) { return userLens_1.getName.get(a.user).localeCompare(userLens_1.getName.get(b.user)); })
            .map(function (rec) { return (__assign(__assign({}, rec), { distributionName: l.name })); });
    });
};
var disabledFields = {
    remove: true,
    add: true,
    deliveryMethod: true,
    printProvider: true,
    finishing: true,
    exclude: true,
    quantity: true
};
var listView = function (props) {
    var recipients = (0, functions_1.distributionRecipients)(props.values.orderRecipients);
    var listRecipients = distributionListRecipients(props);
    var r = __spreadArray(__spreadArray([], recipients, true), fp.array.flatten(listRecipients), true);
    if (props.step2.display === 'LIST') {
        if (hasError(props)) {
            return (React.createElement(GenericErrorMessage_1.default, null,
                React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: props.fetchOrderInformations })));
        }
        else if (isFetching(props)) {
            return (React.createElement("div", { className: 'step2-list-loading-spinner' },
                React.createElement(sok_ui_1.LoadingSpinner, null)));
        }
        var showDistributionList = props.values.distributionLists.length > 0;
        var showRecipientList = Object.values(props.values.orderRecipients).length > 0 ||
            props.values.distributionLists.length > 0;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'disclaimer' },
                React.createElement("div", null, (0, translation_1.getLocalization)('userfront/order/step2/info'))),
            React.createElement("div", { className: 'step-controls' },
                React.createElement(sok_ui_1.Button, { color: 'base-blue', size: 'large', text: (0, translation_1.getLocalization)('userfront/order/step2/addDistribution'), onClick: props.changeStep2View('ADD_DISTRIBUTION_LIST'), disabled: props.disableWizardFields }),
                React.createElement(sok_ui_1.Button, { color: 'base-green', size: 'large', text: (0, translation_1.getLocalization)('userfront/order/step2/addRecipient'), onClick: props.changeStep2View('ADD_RECIPIENT'), disabled: props.disableWizardFields })),
            showDistributionList && (React.createElement("div", { className: 'container' },
                React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/order/step2/selectedDistributions')),
                React.createElement(DistributionLists_1.default, { wizard: props.wizard, deliveryMethods: props.deliveryMethods, finishings: props.finishings, printProviders: props.printProviders, removeDistributionList: props.removeDistributionList, disabled: props.disableWizardFields }))),
            showRecipientList && (React.createElement("div", { className: 'container recipient-container' },
                React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/distribution/list')),
                React.createElement(DistributionRecipients_1.default, { quantities: quantities, disabledFields: props.disableWizardFields ? disabledFields : {}, distributionRecipients: r, type: 'ORDER', distributionLists: props.values.distributionLists, deliveryMethods: props.deliveryMethods, finishings: props.finishings, printProviders: props.printProviders, removeDistributionRecipient: props.removeDistributionRecipient, changeDistributionRecipientQuantity: props.changeDistributionRecipientQuantity, changeDistributionRecipientFinishing: props.changeDistributionRecipientFinishing, changeDistributionRecipientDeliveryMethod: props.changeDistributionRecipientDeliveryMethod, changeDistributionRecipientPrintProvider: props.changeDistributionRecipientPrintProvider, addDistributionRecipient: props.addDistributionRecipient, fetchRecipients: props.fetchRecipients, excludeRecipient: props.excludeRecipient, mode: props.mode, errors: props.wizard.values.status === 'ERROR'
                        ? props.wizard.values.errors
                        : undefined, allowedPrintProviders: (props.currentProject &&
                        props.currentProject.printProvider && [
                        props.currentProject.printProvider
                    ]) ||
                        [] }))),
            !showRecipientList && !showDistributionList && (React.createElement("div", { className: 'no-recipients-message' },
                React.createElement("img", { src: noRecipientIcon }),
                React.createElement("div", null,
                    React.createElement("b", null, (0, translation_1.getLocalization)('userfront/distribution/step2/thereAreNo')),
                    React.createElement("span", null,
                        (0, translation_1.getLocalization)('userfront/distribution/step2/use'),
                        ' ',
                        React.createElement("i", null, (0, translation_1.getLocalization)('userfront/distribution/step2/add')),
                        ' ',
                        (0, translation_1.getLocalization)('userfront/distribution/step2/toAttach')))))));
    }
    return undefined;
};
exports.listView = listView;
var addRecipient = function (props) {
    if (props.step2.display === 'ADD_RECIPIENT') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'disclaimer' },
                React.createElement("div", null, (0, translation_1.getLocalization)('userfront/order/step2/info'))),
            props.step2.addNewDeliveryAddress && (React.createElement(addNewRecipient_1.default, { currentFolder: props.currentFolder, show: props.step2.addNewDeliveryAddress })),
            React.createElement("div", { className: 'container' },
                React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/distribution/step2/addList')),
                props.step2.tab === 0 ? (React.createElement("div", { className: 'add-recipients-tools' },
                    React.createElement(sok_ui_1.Button, { color: 'base-green', size: 'large', onClick: function () {
                            var users = props.recipients.list.status === 'FETCHED'
                                ? props.recipients.list.users.filter(function (row) {
                                    return props.recipients.selected.lastIndexOf(row.id) > -1;
                                })
                                : [];
                            return props.addDistributionRecipient(users.map(function (u) { return ({
                                finishing: (0, functions_1.getFirstItemId)(props.finishings.list),
                                deliveryMethod: -1,
                                printProvider: props.currentProject.printProvider
                                    ? props.currentProject.printProvider
                                    : -1,
                                quantity: 1,
                                user: u
                            }); }), props.recipients.selected)();
                        }, disabled: !props.recipients.selected.length, text: (0, translation_1.getLocalization)('userfront/distribution/step2/addSelected') }),
                    React.createElement(sok_ui_1.Button, { size: 'large', onClick: props.closeDistributionListView(props), color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel') }))) : (React.createElement("div", { className: 'address-book-tools' },
                    React.createElement(sok_ui_1.Button, { color: 'base-blue', onClick: props.changeStep2AddNewDeliveryAddress(true), size: 'large', text: (0, translation_1.getLocalization)('userfront/distribution/step2/addNewDeliveryAddress') }),
                    React.createElement(sok_ui_1.Button, { color: 'base-green', size: 'large', onClick: function () {
                            var users = props.addressBook.list.status === 'FETCHED'
                                ? props.addressBook.list.users.filter(function (row) {
                                    return props.addressBook.selected.lastIndexOf(row.id) > -1;
                                })
                                : [];
                            return props.addDistributionRecipient(users.map(function (u) { return ({
                                finishing: (0, functions_1.getFirstItemId)(props.finishings.list),
                                deliveryMethod: -1,
                                printProvider: props.currentProject.printProvider
                                    ? props.currentProject.printProvider || -1
                                    : -1,
                                quantity: 1,
                                user: u
                            }); }), props.addressBook.selected)();
                        }, disabled: !props.addressBook.selected.length, text: (0, translation_1.getLocalization)('userfront/distribution/step2/addFromAddressbook') }),
                    React.createElement(sok_ui_1.Button, { size: 'large', onClick: props.closeDistributionListView(props), color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel') }))),
                React.createElement(sok_ui_1.Tabs, { className: 'sok-order-wizard-tabsbar', activeIndex: props.step2.tab, onClick: props.changeStep2Tab },
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/recipients')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distribution/addressBook')),
                    React.createElement(AddRecipients_1.default, { currentProject: props.currentProject, recipients: props.recipients, addressBook: props.addressBook, unselectRecipientsList: props.unselectRecipientsList, selectRecipientsList: props.selectRecipientsList, fetchRecipients: props.fetchRecipients, changeStep2View: props.changeStep2View }),
                    React.createElement(AddressBook_1.default, { currentFolder: props.currentFolder, addressBook: props.addressBook, recipients: props.recipients, selectAddressBookList: props.selectAddressBookList, unselectAddressBookList: props.unselectAddressBookList, changeStep2View: props.changeStep2View, fetchExternalUsers: props.fetchExternalUsers })))));
    }
    return undefined;
};
exports.addRecipient = addRecipient;
var addDistributionList = function (props) {
    if (props.step2.display === 'ADD_DISTRIBUTION_LIST') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'disclaimer' },
                React.createElement("div", null, (0, translation_1.getLocalization)('userfront/order/step2/orderInfo'))),
            React.createElement("div", { className: 'container' },
                React.createElement("h3", null, (0, translation_1.getLocalization)('userfront/order/step2/addDistributionList')),
                React.createElement("div", { className: 'add-recipients-tools' },
                    React.createElement(sok_ui_1.Button, { color: 'base-green', size: 'large', onClick: props.addDistributionList(props, props.distributionLists.list.status === 'FETCHED'
                            ? props.distributionLists.list.lists.filter(function (row) {
                                return props.distributionLists.selected.lastIndexOf(row.id) >
                                    -1;
                            })
                            : []), disabled: props.distributionLists.list.status === 'FETCHED' &&
                            !props.distributionLists.selected.length, text: (0, translation_1.getLocalization)('userfront/distribution/step2/addSelected') }),
                    React.createElement(sok_ui_1.Button, { size: 'large', onClick: props.closeDistributionListView(props), color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/button/cancel') })),
                React.createElement(sok_ui_1.Tabs, { className: 'sok-order-wizard-tabsbar', activeIndex: 0 },
                    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/order/step4/delivery/distributionList')),
                    React.createElement(AddDistributionLists_1.default, { currentProject: props.currentProject, distributionLists: props.distributionLists, unselectDistributionList: props.unselectDistributionList, selectDistributionList: props.selectDistributionList, fetchDistributionLists: props.fetchDistributionLists })))));
    }
    return undefined;
};
exports.addDistributionList = addDistributionList;
exports.Component = enhance(function (props) { return (React.createElement("div", { className: 'order-wizard-step2' },
    (0, exports.listView)(props),
    (0, exports.addRecipient)(props),
    (0, exports.addDistributionList)(props))); });
exports.default = exports.Component;
